import { render, staticRenderFns } from "./productReturnAndExchange.vue?vue&type=template&id=5fd22335&scoped=true&"
import script from "./productReturnAndExchange.vue?vue&type=script&lang=js&"
export * from "./productReturnAndExchange.vue?vue&type=script&lang=js&"
import style0 from "./productReturnAndExchange.vue?vue&type=style&index=0&id=5fd22335&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd22335",
  null
  
)

export default component.exports